import { styled } from '@linaria/react';

export const SIZES = ['L', 'M'] as const;
export type TSize = (typeof SIZES)[number];

export const HEIGHT = {
	M: '3.8rem',
	L: '4.4rem',
};

export const STYLES = ['primary', 'secondary'] as const;
export type TStyle = (typeof STYLES)[number];

const BASIC_BACKGROUNDS = {
	primary: 'var(--color-white-xs)',
	secondary: 'var(--color-grey-7-solid)',
};

const FOCUS_BACKGROUNDS = {
	primary: 'var(--color-grey-16-solid)',
	secondary: 'var(--color-grey-7-solid)',
};

const DISABLED_BACKGROUNDS = {
	primary: 'var(--color-white-xxs)',
	secondary: 'var(--color-grey-10-solid)',
};

export const Input = styled.input<{ uiSize?: TSize; uiStyle?: TStyle }>`
	--input-height: ${({ uiSize }) => HEIGHT[uiSize ?? 'M']};
	height: var(--input-height);
	border: 1px solid var(--color-grey-19-solid);
	border-radius: var(--radius-xs);

	backdrop-filter: blur(25px);

	background-color: ${({ uiStyle }) => BASIC_BACKGROUNDS[uiStyle ?? 'primary']};
	color: var(--color-grey-95-solid);

	font-size: var(--font-size-l);
	line-height: var(--line-height-text-m);
	padding-inline: 10px;

	transition: border-color 0.3s;

	&::placeholder {
		color: var(--color-grey-68-solid);
	}

	/* stylelint-disable */
	&:focus {
		border-color: var(--color-grey-95-solid);
		background-color: ${({ uiStyle }) =>
			FOCUS_BACKGROUNDS[uiStyle ?? 'primary']};
	}

	&[disabled] {
		background-color: ${({ uiStyle }) =>
			DISABLED_BACKGROUNDS[uiStyle ?? 'primary']};
		pointer-events: none;
		&::placeholder {
			color: var(--color-grey-52-solid);
		}
	}
	/* stylelint-enable */

	&:is(select) {
		padding-right: 3.2rem;
		appearance: none;
		background-image: url('/assets/icons/chevron-down.svg');
		background-position: right 1.2rem center;
		background-repeat: no-repeat;
		background-size: 2.2rem 2.2rem;
		cursor: pointer;

		option {
			background-color: ${({ uiStyle }) =>
				BASIC_BACKGROUNDS[uiStyle ?? 'primary']};
			color: var(--color-grey-95-solid);
		}
	}
`;
